/**
 * 首页控制台
 */
import Layout from '../../pages/layout/Frame';

const indexRouter = {
    path: "/dashboard",
    component: Layout,
    meta: {title: '首页控制台'},
    name: "dashboard",
    children: [
        {
            path: "/dashboard/index",
            component: () => import('../../pages/dashboard/Index.vue'),
            meta: {title: '首页控制台'},
            name: 'dashboard_index',
        },
    ]
};

export default indexRouter
